<template>
  <div class="form-group" :class="{ 'has-error': hayError }">
    <label v-if="labelFinal" class="control-label">
      <abbr v-if="required" title="requerido">*</abbr>
      {{ labelFinal }}
    </label>
    <input
      ref="input"
      v-model="model"
      :type="type"
      class="form-control"
      :value="modelValue"
      :placeholder="placeholder"
    />
    <span
      v-if="hayError"
      class="help-block text-danger"
    >
      {{ errorNormalizado }}
    </span>
  </div>
</template>

<script>
import { isNil } from 'lodash';

export default {
  props: {
    type: { type: String, default: 'text' },
    label: { type: String, default: null },
    // Se le indica un key de la traducción
    labelKey: { type: String, default: null },
    modelValue: { type: String, default: '' },
    error: { type: [String, Array], default: null },
    required: { type: Boolean, default: false },
    placeholder: { type: String, default: '' },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      errorInterno: this.error,
    };
  },
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
    labelFinal() {
      let { label } = this;

      if (!label && this.labelKey) {
        label = this.$I18n.t(this.labelKey);
      }
      return label;
    },
    hayError() {
      return !isNil(this.errorInterno);
    },
    errorNormalizado() {
      if (!Array.isArray(this.errorInterno)) {
        return this.errorInterno;
      }
      return this.errorInterno.join('<br/>');
    },
  },
  watch: {
    error(value) {
      this.errorInterno = value;
    },
    model() {
      // Cuando cambian el valor, limpiamos el error
      this.errorInterno = null;
    },
  },
  methods: {
    focus() {
      this.$refs.input.focus();
    },
  },
};
</script>

<style scoped>
  abbr {
    border: 0;
    text-decoration: none;
    color: #fe1d12;
  }
</style>
